import Api from '@services/api';
import {removeEmptyParams} from '@utils';

export default {
  findAll(filter) {
    return Api()
      .get('/threads/pagination', {params: removeEmptyParams(filter)})
      .then((res) => res.data);
  },
  getDetails(threadId) {
    return Api()
      .get(`/thread/${threadId}`)
      .then((res) => res.data);
  },
  sendMessage(threadId, content, files, clientMessageId) {
    let formData = new FormData();
    formData.append('message', new Blob([JSON.stringify({content, clientMessageId})], {type: 'application/json'}));
    if (files) Array.from(files).forEach((f) => formData.append('files', f));
    return Api()
      .post(`/thread/${threadId}/message`, formData, {
        transformRequest: (data) => data,
      })
      .then((res) => res.data);
  },
  resendMessage(threadId, messageId) {
    return Api()
      .post(`/thread/${threadId}/message/${messageId}/resend`)
      .then((res) => res.data);
  },
  archive(threadId) {
    return Api()
      .post(`/thread/${threadId}/archive`)
      .then((res) => res.data);
  },
  toggleFavorite(threadId) {
    return Api()
      .post(`/thread/${threadId}/favorite`)
      .then((res) => res.data);
  },
  assignableEmployees() {
    return Api()
      .get('/threads/assignable-employees')
      .then((res) => res.data);
  },
  assignEmployee(threadId, employeeId) {
    return Api()
      .post(`/thread/${threadId}/assign/${employeeId}`)
      .then((res) => res.data);
  },
  unassignEmployee(threadId) {
    return Api()
      .delete(`/thread/${threadId}/assign`)
      .then((res) => res.data);
  },
  createInternalNote(threadId, content) {
    return Api()
      .post(`/thread/${threadId}/internalNote`, content, {headers: {'Content-Type': 'text/plain'}})
      .then((res) => res.data);
  },
  markInternalNotesRead(threadId) {
    return Api()
      .post(`/internalNote/thread/${threadId}/read`)
      .then((res) => res.data);
  },
  deleteInternalNote(internalNoteId) {
    return Api()
      .delete(`/internalNotes/${internalNoteId}`)
      .then((res) => res.data);
  },
};
